module.exports = __webpack_public_path__ + "img/groupMain.56b35b08.svg";